<template>
  <div class="beige" :class="{ flash }">
    <v-icon class="beige-ico">
      mdi-information-outline
    </v-icon>
    <span class="beige-text">{{ text }}</span>
  </div>
</template>

<script>
  import { HINTS } from '@/constants/deliveryZones'

  export default {
    name: 'BeigeHintBar',
    props: {
      drawing: { type: Boolean, default: false },
      filialMode: { type: [String, Number], default: 'all' },
      color: { type: String, default: 'green' },
      modalOpen: { type: Boolean, default: false },
    },
    data: () => ({ text: HINTS.all, flash: false }),
    computed: {
      target () {
        if (this.drawing) return HINTS.drawing
        if (this.filialMode === 'all') return HINTS.all
        return HINTS[this.color] || HINTS.green
      },
    },
    watch: {
      target: {
        immediate: true,
        handler (msg) {
          if (this.modalOpen) return
          if (msg === this.text) return
          this.text = msg
          this.flash = false
          this.$nextTick(() => {
            this.flash = true
          })
        },
      },
    },
  }
</script>

<style scoped>
  .beige {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #fdf6e3;
    border: 1px solid #f3e6bf;
    border-radius: 10px;
    padding: 12px 16px;
    color: #6b5b2e;
    font-size: 14px;
    margin-bottom: 12px;
  }
  .beige .beige-ico {
    color: #fb8c00;
    font-size: 20px;
  }
  .beige.flash {
    animation: beigeflash 0.35s ease;
  }
  @keyframes beigeflash {
    from {
      opacity: 0.3;
    }
    to {
      opacity: 1;
    }
  }
</style>
